import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withFragmentIdProp,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    PackingListCreate,
    PackingListDto,
    PackingListRead,
    PackingListSearchParams,
} from '../../entities/packing-list.dto';
import {
    CustomFieldMetadataMap,
    DimensionsMetadataMap,
    ResourceAuthSymbol,
    UserFragmentSymbol,
    WeightMetadataMap,
} from '@pf/shared/util-platform';
import { withWarehouseSearchFilter } from '../wms-mapping.util';
import { PackLineMetadataMap } from '../pack-lines/pack-line.mapping-profile';

const symbols = entitySymbols(PFWmsEntities.PackingList);

withDefaultEntityMetadata<PackingListDto>(symbols.dto, {
    packLines: [PackLineMetadataMap.symbols.dto],
    customFields: [CustomFieldMetadataMap.symbols.dto],
    customer: Object,
    item: Object,
    packingListDate: String,
    packingListNumber: String,
    pickListId: String,
    projectId: String,
    resourceAuth: ResourceAuthSymbol,
    shipmentId: String,
    status: String,
    warehouse: Object,
    assignedToUser: UserFragmentSymbol,
    weight: WeightMetadataMap.symbols.dto,
    dimensions: DimensionsMetadataMap.symbols.dto,
});

withDefaultEntityMetadata<PackingListRead>(symbols.entity, {
    packLines: [PackLineMetadataMap.symbols.entity],
    customFields: [CustomFieldMetadataMap.symbols.entity],
    customer: Object,
    item: Object,
    packingListDate: String,
    packingListNumber: String,
    pickListId: String,
    projectId: String,
    resourceAuth: ResourceAuthSymbol,
    shipmentId: String,
    status: String,
    warehouse: Object,
    assignedToUser: UserFragmentSymbol,
    weight: WeightMetadataMap.symbols.entity,
    dimensions: DimensionsMetadataMap.symbols.entity,
});

withMetadata<PackingListCreate>(symbols.createBody, {
    customerId: String,
    itemId: String,
    packingListDate: String,
    packingListNumber: String,
    pickListId: String,
    projectId: String,
    resourceAuth: ResourceAuthSymbol,
    shipmentId: String,
    status: String,
    warehouseId: String,
    assignedToUserId: String,
    weight: WeightMetadataMap.symbols.createBody,
    dimensions: DimensionsMetadataMap.symbols.createBody,
});

withDefaultSearchParamsMetadata<PackingListSearchParams>(symbols.searchParams, {
    warehouseId: String,
    projectId: String,
});

export const PackingListMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<PackingListRead, PackingListDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<PackingListDto, PackingListRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<PackingListDto, PackingListCreate>(
            mapper,
            symbols.dto,
            symbols.createBody,
            withFragmentIdProp('item'),
            withFragmentIdProp('customer'),
            withFragmentIdProp('warehouse'),
            withFragmentIdProp('assignedToUser')
        );
        createMap<IQueryParams<PackingListDto>, PackingListSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withWarehouseSearchFilter(),
            withSearchFilter('projectId'),
            ...withDefaultSearchParamsMappingConfiguration()
        );

        WeightMetadataMap.profile(mapper);
        DimensionsMetadataMap.profile(mapper);
    },
};
